import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StudentExtraHelpService {
  isStreaming$ = new EventEmitter<boolean>(false);
  selectedQuestion = new EventEmitter<object>();
  constructor() {}
}
